import { computable, iterable, observable, patch } from "@chorda/core";
import { Field, Fields } from "chorda-bulma";
import { Coerced, createValueEffect } from "../../utils";
import { BgImage, DropdownOld, DropdownOldItem } from "../../helpers";
import { CatApi } from "../../api";
const ORDERS = observable([
    { id: 'random', name: 'Random' },
    { id: 'desc', name: 'Desc' },
    { id: 'asc', name: 'Asc' },
]);
const LIMITS = observable([
    { id: 9, name: '9' },
    { id: 18, name: '18' },
    { id: 80, name: '80' },
]);
export const Favourites = () => {
    return {
        injections: {
            images: () => observable(null),
            limit: () => observable(9),
            page: () => observable(null),
            order: () => observable('random'),
            filters: ({ limit, page }) => computable(() => {
                return { limit, page };
                // return {
                //     limit: scope.limit, 
                //     page: scope.page
                // }
            })
        },
        joints: {
            autoLoad: ({ images, filters }) => {
                const search = createValueEffect(images, 'loadFavourites', CatApi.api.searchFavourites);
                filters.$subscribe(next => {
                    //                        debugger
                    search(next);
                });
            }
        },
        styles: {
            width: '600px',
            margin: '0 auto'
        },
        templates: {
            header: {
                css: 'mb-5',
                items: [
                    Field({
                        label: 'Order',
                        control: DropdownOld({
                            items$: (scope) => ORDERS,
                            value$: (scope) => scope.order,
                            text$: (scope) => scope.selected.name,
                            defaultItem: DropdownOldItem({
                                text$: (scope) => scope.item.name
                            })
                        })
                    })
                ]
            },
            images: {
                css: 'catapi-search',
                templates: {
                    tiles: Coerced({
                        css: 'flex-tiles',
                        injections: {
                            __it: (scope) => iterable(scope.images)
                        },
                        reactions: {
                            __it: (v) => patch({ items: v })
                        },
                        defaultItem: Coerced({
                            css: 'flex-tile',
                            templates: {
                                content: BgImage({
                                    url$: (scope) => scope.__it.image.url
                                })
                            }
                        })
                    })
                }
            },
            footer: {
                css: 'mt-5',
                templates: {
                    content: Fields({
                        fields: [
                            Field({
                                label: 'Per page',
                                control: DropdownOld({
                                    value$: (scope) => scope.limit,
                                    text$: (scope) => scope.selected.name,
                                    items$: () => LIMITS,
                                    defaultItem: DropdownOldItem({
                                        text$: (scope) => scope.item.name
                                    })
                                })
                            }),
                            // Field({
                            //     control: Button({
                            //         text: 'More',
                            //         css: 'is-info is-medium',
                            //         rightIcon: FaIcon({icon: faRedo}),
                            //         onClick: (e, {bus}) => {
                            //             bus.$emit('loadNextPage')
                            //         }
                            //     }),
                            // })
                        ]
                    })
                }
            }
        }
    };
};
